import { useTranslation } from "react-i18next";
import { LifestyleUseCasesData } from "./types";

// Helper function برای تبدیل امن به array
const ensureArray = (value: any): string[] => {
    if (Array.isArray(value)) {
        return value;
    }
    if (typeof value === "string") {
        return [value];
    }
    if (value && typeof value === "object") {
        return Object.values(value).filter((v): v is string => typeof v === "string");
    }
    return [];
};

export const useWatchLifestyleData = (): LifestyleUseCasesData => {
    const { t } = useTranslation("watchLifestyle");

    return {
        categories: [
            { id: "control", name: t("categories.control") },
            { id: "health", name: t("categories.health") },
            { id: "utility", name: t("categories.utility") },
        ],

        useCases: [
            /* ──────────────── کنترل و امنیت (Control) ──────────────── */
            {
                image: "../../../../media/landing/LifestyleUseCases/watch/1.webp",
                title: t("useCases.0.title"),
                description: t("useCases.0.description"),
                time: t("useCases.0.time"),
                category: "control",
                color: "from-orange-400 to-red-500",
                main: true,
                tags: ensureArray(t("useCases.0.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/watch/2.webp",
                title: t("useCases.1.title"),
                description: t("useCases.1.description"),
                time: t("useCases.1.time"),
                category: "control",
                color: "from-orange-400 to-red-500",
                main: true,
                tags: ensureArray(t("useCases.1.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/watch/3.webp",
                title: t("useCases.2.title"),
                description: t("useCases.2.description"),
                time: t("useCases.2.time"),
                category: "control",
                color: "from-blue-400 to-indigo-500",
                main: true,
                tags: ensureArray(t("useCases.2.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/watch/4.webp",
                title: t("useCases.3.title"),
                description: t("useCases.3.description"),
                time: t("useCases.3.time"),
                category: "control",
                color: "from-purple-400 to-fuchsia-500",
                main: true,
                tags: ensureArray(t("useCases.3.tags", { returnObjects: true })),
            },

            /* ──────────────── پایش سلامت (Health) ──────────────── */
            {
                image: "../../../../media/landing/LifestyleUseCases/watch/5.webp",
                title: t("useCases.4.title"),
                description: t("useCases.4.description"),
                time: t("useCases.4.time"),
                category: "health",
                color: "from-orange-400 to-red-500",
                main: true,
                tags: ensureArray(t("useCases.4.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/watch/6.webp",
                title: t("useCases.5.title"),
                description: t("useCases.5.description"),
                time: t("useCases.5.time"),
                category: "health",
                color: "from-blue-400 to-indigo-500",
                main: true,
                tags: ensureArray(t("useCases.5.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/watch/7.webp",
                title: t("useCases.6.title"),
                description: t("useCases.6.description"),
                time: t("useCases.6.time"),
                category: "health",
                color: "from-amber-400 to-yellow-500",
                main: true,
                tags: ensureArray(t("useCases.6.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/watch/8.webp",
                title: t("useCases.7.title"),
                description: t("useCases.7.description"),
                time: t("useCases.7.time"),
                category: "health",
                color: "from-purple-400 to-fuchsia-500",
                main: true,
                tags: ensureArray(t("useCases.7.tags", { returnObjects: true })),
            },

            /* ──────────────── ابزار هوشمند (Utility) ──────────────── */
            {
                image: "../../../../media/landing/LifestyleUseCases/watch/9.webp",
                title: t("useCases.8.title"),
                description: t("useCases.8.description"),
                time: t("useCases.8.time"),
                category: "utility",
                color: "from-orange-400 to-red-500",
                main: true,
                tags: ensureArray(t("useCases.8.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/watch/10.webp",
                title: t("useCases.9.title"),
                description: t("useCases.9.description"),
                time: t("useCases.9.time"),
                category: "utility",
                color: "from-blue-400 to-indigo-500",
                main: true,
                tags: ensureArray(t("useCases.9.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/watch/11.webp",
                title: t("useCases.10.title"),
                description: t("useCases.10.description"),
                time: t("useCases.10.time"),
                category: "utility",
                color: "from-amber-400 to-yellow-500",
                main: true,
                tags: ensureArray(t("useCases.10.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/watch/12.webp",
                title: t("useCases.11.title"),
                description: t("useCases.11.description"),
                time: t("useCases.11.time"),
                category: "utility",
                color: "from-purple-400 to-fuchsia-500",
                main: true,
                tags: ensureArray(t("useCases.11.tags", { returnObjects: true })),
            },
        ],
    };
};
